import { useContext } from 'react';
import { DialogContext } from '../components/Dialog/DialogContext';
export var useDialog = function () { return useContext(DialogContext); };
